import {
	SET_PUBLIC_USER_BRAND,
	SET_PUBLIC_USER_BRAND_REPO,
	SET_PUBLIC_USER_BRAND_RESET,
} from "./actions";

const INITIAL_STATE = {
	brand: null,
	brandRepo: null,
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case SET_PUBLIC_USER_BRAND:
		return {
			...state,
			brand: action.publicUserBrand,
		};
	case SET_PUBLIC_USER_BRAND_REPO:
		return {
			...state,
			brandRepo: action.publicUserBrandRepo,
		};
	case SET_PUBLIC_USER_BRAND_RESET:
		return {
			...state,
			...INITIAL_STATE,
		};
	default:
		return state;
	}
};
